<script>
import EditDischargeSummary from "@/components/commons/InitiateDischarge.vue";
export default {
    name: "ViewDischargeSummary",

    data() {

        return {
            editDischarge: false,
            doctorsNurses: [],
        };
    },

    props: {

        patient: Object,
        showModal: Boolean,
        dischargeSummary: Object,
        prescriptions: Array,
        appointments: Array
    },

    methods: {

        fetchConsultants() {
          return this.$http
            .get(`Shared/GetActiveConsultants`)
            .then(({ data }) => {
              this.doctorsNurses = data;
            })
            .catch(() => {});
        },

        printDischargeSummary() {
            let url = `/admissions/discharge-summary`;
                url += `?patientID=${this.dischargeSummary.patientID}`;
                url += `&visitNo=${this.dischargeSummary.visitNo}`;

            window.open(url, 
                '_blank', 
                `DischargeSummaryPrint`,);
        },
    },

    components: {
        "edit-discharge-summary": EditDischargeSummary,
    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="md:w-2/3 w-11/12">
  <template v-slot:title>
    <h5 class="font-medium text-sm">Discharge Summary</h5>
  </template>
  <template v-slot:modal-body>
    <div class="flex flex-wrap items-center">
        <div class="w-full flex flex-wrap border-2 border-gray-400 mb-2 rounded-t-md">
            <div class="w-full p-1 bg-gray-400 rounded-t-md">
                <h5 class="font-medium text-sm">Patient Details</h5>
            </div>
            <div class="w-full p-1">
                <h5 class="font-bold text-sm">
                    Name: {{ patient.names }}</h5>
            </div>
            <div class="md:w-1/3 w-1/2 p-1">
                <h5 class="font-bold text-sm">
                    MRN: {{ patient.patienT_ID }}</h5>
            </div>
            <div class="md:w-1/3 w-1/2 p-1">
                <h5 class="font-bold text-sm">
                    IP: {{ patient.ipfileno }}</h5>
            </div>
            <div class="md:w-1/3 w-1/2 p-1">
                <h5 class="font-bold text-sm">
                    OP: {{ patient.opfileno || `-` }}</h5>
            </div>
            <div class="md:w-1/3 w-1/2 p-1">
                <h5 class="font-bold text-sm">
                    DOB: {{ patient.dob | dateFormat }}</h5>
            </div>
            <div class="md:w-1/3 w-1/2 p-1">
                <h5 class="font-bold text-sm">
                    Age: {{ patient.age || `-` }} Yr(s)</h5>
            </div>
            <div class="md:w-1/3 w-1/2 p-1">
                <h5 class="font-bold text-sm">
                    Gender: {{ patient.gender }}</h5>
            </div>
        </div>
        <div class="w-full flex flex-wrap mb-2 rounded-t-md border-2 border-gray-400">
            <div class="w-full p-1 bg-gray-400 rounded-t-md">
                <h5 class="font-medium text-sm">
                    Admission Details</h5>
            </div>
            <div class="md:w-1/4 w-full p-2">
                <h5 class="font-medium text-sm">Admission Date: 
                    {{ dischargeSummary.dateofAdmission | dateFormat }}</h5>
            </div>
            <div class="md:w-1/4 w-full p-2">
                <h5 class="font-medium text-sm">Discharge Date: 
                    {{ dischargeSummary.dateofDischarge | dateFormat }} </h5>
            </div>
        </div>
        <div class="w-full flex flex-wrap border-2 border-gray-400 rounded-t-md">
            <div class="w-full p-1 bg-gray-400 rounded-t-md">
                <h5 class="font-medium text-sm">Diagnosis</h5>
            </div>
            <div class="flex-1 p-1">
                <h5 class="font-medium my-1 text-sm">Diagnosis On Discharge</h5> 
                <span class="text-xs mt-2" 
                    v-html="dischargeSummary.diagnosis || `-`"></span>
                <h5 class="font-medium text-sm my-1">Major Complaints</h5>
                <span class="text-xs my-2" 
                    v-html="dischargeSummary.majorComplaints || `-`"></span>
                
            </div>
            <div class="flex-1 p-1">
                <h5 class="font-medium my-1 text-sm">Physical Findings  at Admission</h5>
                <span class="text-xs my-2" 
                    v-html="dischargeSummary.physicalFindings || `-`"></span>
            </div> <div class="flex-1 p-1">
                <h5 class="font-medium my-1 text-sm">Physical Findings as Discharge</h5>
                <span class="text-xs my-2" 
                    v-html="dischargeSummary.physicalFindingsatDischarge || `-`"></span>
            </div>
        </div>
        <div class="w-full flex flex-wrap rounded-t-md border-2 border-gray-400 mt-2">
            <div class="w-full p-1 bg-gray-400 rounded-t-md">
                <h5 class="font-medium text-sm">Investigations / Procedures</h5>
            </div>
            <div class="w-full p-1">
                <h5 class="font-medium my-1 text-sm">Investigations</h5>
                <span class="text-xs mt-2" 
                    v-html="dischargeSummary.investigationsdone || `-`"></span>
                    <h5 class="font-medium my-1 text-sm">Procedures done</h5>
                <span class="text-xs my-2" 
                    v-html="dischargeSummary.proceduresdone || `-`"></span>
                    <h5 class="font-medium my-1 text-sm">Post Procedures Status</h5>
                <span class="text-xs my-2" 
                    v-html="dischargeSummary.postProcedureStatus || `-`"></span>
                <h5 class="font-medium my-1 text-sm"  v-if="$root.checkAuth('DisplayDrugReceivedOnDischargeSummary')">Drugs Received</h5>
                <span class="text-xs my-2"   v-if="$root.checkAuth('DisplayDrugReceivedOnDischargeSummary')"
                    v-html="dischargeSummary.drugsReceived || `-`"></span>
            </div>
        </div>
         <div class="w-full flex flex-wrap rounded-t-md border-2 border-gray-400 mt-2">
            <div class="w-full p-1 bg-gray-400 rounded-t-md">
                <h5 class="font-medium text-sm">Diagnosis on Admission</h5>
            </div>
            <div class="w-full p-1">
                <span class="text-xs mt-2" 
                    v-html="dischargeSummary.diagnosisOnAdmission || `-`"></span>
                
            </div>
        </div>
        <div class="w-full flex flex-wrap border-2 border-gray-400 rounded-t-md my-2">
            <div class="w-full p-1 bg-gray-400 rounded-t-md">
                <h5 class="font-medium text-sm">Progress/Condition on Discharge</h5>
            </div>
            <div class="w-full p-1">
                <span class="text-xs" 
                    v-html="dischargeSummary.progress || `-`"></span>
            </div>
        </div> <div class="w-full flex flex-wrap border-2 border-gray-400 rounded-t-md my-2">
            <div class="w-full p-1 bg-gray-400 rounded-t-md">
                <h5 class="font-medium text-sm">Special Instructions:</h5>
            </div>
            <div class="w-full p-1">
                <span class="text-xs" 
                    v-html="dischargeSummary.specialInstructions || `-`"></span>
            </div>
        </div> <div class="w-full flex flex-wrap border-2 border-gray-400 rounded-t-md my-2">
            <div class="w-full p-1 bg-gray-400 rounded-t-md">
                <h5 class="font-medium text-sm">Warning Signs:Return to Hospital if you Experience</h5>
            </div>
            <div class="w-full p-1">
                <span class="text-xs" 
                    v-html="dischargeSummary.warningSigns || `-`"></span>
            </div>
        </div>
        <div class="w-full flex flex-wrap rounded-t-md border-2 border-gray-400">
            <div class="w-full p-1 bg-gray-400 rounded-t-md">
                <h5 class="font-medium text-sm">Drugs Discharged On</h5>
            </div>
            <div class="w-full overflow-auto p-1 my-1">
                <table class="table">
                    <thead class="bg-blue-500 text-white text-xs">
                        <tr>
                            <th class="p-tiny">Item</th>
                            <th class="p-tiny">Prescription</th>
                        </tr>
                    </thead>
                    <tbody class="bg-gray-100 text-xs">
                        <tr v-for="presc in prescriptions" :key="presc.code">
                            <td class="p-tiny">
                                {{ presc.drug }}</td>
                            <td class="p-tiny">
                                {{ presc.description || `-` }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="w-full flex flex-wrap border-2 border-gray-400 my-2 rounded-t-md">
            <div class="w-full p-1 bg-gray-400 rounded-t-md">
                <h5 class="font-medium text-sm">Appointments</h5>
            </div>
            <div class="w-full overflow-auto p-1">
                <table class="table table-hover">
                    <thead class="bg-blue-500 text-white text-xs">
                       <tr class="w-full flex">
                           <th class="p-tiny flex-1">Doctor</th>
                           <th class="p-tiny flex-1">Clinic</th>
                           <th class="p-tiny flex-1">TCA/Review Date</th>
                           <th class="p-tiny flex-1">Time</th>
                       </tr> 
                    </thead>
                    <tbody 
                        class="bg-gray-100 text-xs flex flex-col items-center overflow-auto" 
                        style="max-height:35vh;">
                        <tr v-for="(app, idx) in appointments" class="w-full flex" :key="idx">
                            <td class="p-tiny flex-1">
                                {{ app.doctor }}</td>
                            <td class="p-tiny flex-1">
                                {{ app.clinic }}</td>
                            <td class="p-tiny flex-1">
                                {{ app.appointmentDate | dateFormat }}</td>
                            <td class="p-tiny flex-1">
                                {{ app.startTime }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="w-full p-1">
            <h5 class="font-medium my-1 text-sm">Comment</h5>
            <span class="text-xs my-2" 
                v-html="dischargeSummary.recommendations || `-`"></span>
        </div>
        <div class="w-full mt-2 p-1 bg-gray-400 rounded">
            <h5 class="font-medium text-sm">Discharged By: {{ dischargeSummary.clinician }}</h5>
       <h5 class="font-medium text-sm">Signature:________________________________</h5>
        </div>
    </div>
    <edit-discharge-summary 
        :showModal="editDischarge"
        :patient="patient"
        :templates="[]"
        :clinicians="doctorsNurses"
        :dischargeSummary="{ 
            ...dischargeSummary,
            diagnosisonAdmission: dischargeSummary.diagnosisOnAdmission,
            diagnosisonDischarge: dischargeSummary.diagnosis,
            dateofAdmission: $moment(dischargeSummary.dateofAdmission).format(`YYYY-MM-DD`),
            dateofDischarge: $moment(dischargeSummary.dateofDischarge).format(`YYYY-MM-DD`)
        }"
        @closeModal="editDischarge = false"
    />
  </template>
  <template v-slot:modal-footer>
    <button
        @click.prevent="() => {
            $root.loading = true;
            fetchConsultants().then(() => {
                $root.loading = false;
                editDischarge = true;
            });
        }"
        class="btn-sm btn-warning text-xs rounded mr-6">
            <i class="fa fa-pen"></i> Edit Summary</button>
    <button 
        @click.prevent="printDischargeSummary" 
        class="btn-sm btn-primary text-xs rounded mr-6">
            <i class="fa fa-print"></i> Print</button>
    <button 
        class="btn-danger btn-sm text-xs rounded" 
        @click="$emit(`closeModal`)">
            <i class="fa fa-times"></i> Close</button>
  </template>
</tail-modal>
</template>